import { render, staticRenderFns } from "./IncomeSources.vue?vue&type=template&id=660ec478&scoped=true&"
import script from "./IncomeSources.vue?vue&type=script&lang=js&"
export * from "./IncomeSources.vue?vue&type=script&lang=js&"
import style0 from "./IncomeSources.vue?vue&type=style&index=0&id=660ec478&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "660ec478",
  null
  
)

export default component.exports